import { render, staticRenderFns } from "./TransactionsDialog.vue?vue&type=template&id=4237c53b&scoped=true"
import script from "./TransactionsDialog.vue?vue&type=script&lang=js"
export * from "./TransactionsDialog.vue?vue&type=script&lang=js"
import style0 from "./TransactionsDialog.vue?vue&type=style&index=0&id=4237c53b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4237c53b",
  null
  
)

export default component.exports